/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebPublicConfiguration } from '../shiva-web-public-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { decodeReinitToken } from '../fn/personal-space/decode-reinit-token';
import { DecodeReinitToken$Params } from '../fn/personal-space/decode-reinit-token';
import { DecodeReinitTokenResponse } from '../models/decode-reinit-token-response';
import { forgetPasswordUser } from '../fn/personal-space/forget-password-user';
import { ForgetPasswordUser$Params } from '../fn/personal-space/forget-password-user';
import { registerUser } from '../fn/personal-space/register-user';
import { RegisterUser$Params } from '../fn/personal-space/register-user';
import { reinitPasswordUser } from '../fn/personal-space/reinit-password-user';
import { ReinitPasswordUser$Params } from '../fn/personal-space/reinit-password-user';


/**
 * All about the user personal space
 */
@Injectable({ providedIn: 'root' })
export class PersonalSpaceService extends BaseService {
  constructor(config: ShivaWebPublicConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `registerUser()` */
  static readonly RegisterUserPath = '/personalspace/register';

  /**
   * Register a new user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerUser$Response(params: RegisterUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Register a new user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerUser(params: RegisterUser$Params, context?: HttpContext): Observable<void> {
    return this.registerUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forgetPasswordUser()` */
  static readonly ForgetPasswordUserPath = '/personalspace/forget-password';

  /**
   * Password forgotten.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgetPasswordUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgetPasswordUser$Response(params: ForgetPasswordUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forgetPasswordUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Password forgotten.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forgetPasswordUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forgetPasswordUser(params: ForgetPasswordUser$Params, context?: HttpContext): Observable<void> {
    return this.forgetPasswordUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `decodeReinitToken()` */
  static readonly DecodeReinitTokenPath = '/personalspace/decode-reinit-token';

  /**
   * decode a password reinitialisation token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `decodeReinitToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  decodeReinitToken$Response(params: DecodeReinitToken$Params, context?: HttpContext): Observable<StrictHttpResponse<DecodeReinitTokenResponse>> {
    return decodeReinitToken(this.http, this.rootUrl, params, context);
  }

  /**
   * decode a password reinitialisation token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `decodeReinitToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  decodeReinitToken(params: DecodeReinitToken$Params, context?: HttpContext): Observable<DecodeReinitTokenResponse> {
    return this.decodeReinitToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<DecodeReinitTokenResponse>): DecodeReinitTokenResponse => r.body)
    );
  }

  /** Path part for operation `reinitPasswordUser()` */
  static readonly ReinitPasswordUserPath = '/personalspace/reinit-password';

  /**
   * Password reinitialisation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reinitPasswordUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reinitPasswordUser$Response(params: ReinitPasswordUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reinitPasswordUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Password reinitialisation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reinitPasswordUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reinitPasswordUser(params: ReinitPasswordUser$Params, context?: HttpContext): Observable<void> {
    return this.reinitPasswordUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
